import { render, staticRenderFns } from "./ReparacionFormulario.vue?vue&type=template&id=47f4624a"
import script from "./ReparacionFormulario.vue?vue&type=script&lang=js"
export * from "./ReparacionFormulario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports